import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DetailedBlog from "../components/DetailedBlog/DetailedBlog";
import RelatedBlogContainer from "../components/RelatedBlogs/RelatedBlogContainer";
import Goback from "../components/utils/Goback";
import Loading from "../components/utils/Loading";
import { fetchBlog } from "../features/blog/blogSlice";

export default function BlogDetails() {
  const dispatch = useDispatch();
  const { isLoading, isError, blog, error } = useSelector(
    (state) => state.blog
  );
  const { blogId } = useParams();

  useEffect(() => {
    dispatch(fetchBlog(blogId));
  }, [blogId, dispatch]);

  //Decide what to render
  let content;

  if (isLoading) {
    content = <Loading />;
  }

  if (!isLoading && isError) {
    content = <div className="text-lg text-gray-500">{error}</div>;
  }

  if (!isLoading && !isError && !blog?.id) {
    content = <p className="text-lg text-gray-500">No Blogs Found</p>;
  }

  if (!isLoading && !isError && blog?.id) {
    content = (
      <section className="post-page-container">
        <DetailedBlog blog={blog} />
        <RelatedBlogContainer
          id={blog.id}
          tags={blog.tags}
        />
      </section>
    );
  }

  return (
    <>
      <Goback />
      {content}
    </>
  );
}
